// extracted by mini-css-extract-plugin
export default {"Privacy":"Privacy_Privacy__XIWYm","Legal":"Privacy_Legal__aErhE","TermsOfUse":"Privacy_TermsOfUse__laRIQ"};